export default [
  // 添加员工
  {
    name: 'add-teacher',
    component: () => import(/* webpackChunkName: "addTeacherPopup" */ './add-teacher.vue'),
  },
  // 查看权限
  {
    name: 'view-permission',
    component: () => import(/* webpackChunkName: "viewPermission" */ './view-permission.vue'),
  },
  // 添加部门
  {
    name: 'add-depart',
    component: () => import(/* webpackChunkName: "addDepartPopup" */ './add-depart.vue'),
  },
  // 选择部门
  {
    name: 'choose-depart',
    component: () => import(/* webpackChunkName: "chooseDepartPopup" */ './choose-depart.vue'),
  },
  // 设置部门
  {
    name: 'set-depart',
    component: () => import(/* webpackChunkName: "setDepartPopup" */ './set-depart.vue'),
  },
];
